import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import ApexTree from 'apextree'
import { OrgChartService } from '../../services/org-chart.service'
import { Store } from '@ngrx/store'
import { AuthState, selectUser } from '../../store/auth/auth.state'
import { environment } from '../../../environments/environment'
import { Subject, takeUntil } from 'rxjs'
import { color } from 'html2canvas/dist/types/css/types/color'

declare global {
  interface Window {
    orgToggleNode: (nodeId: string) => void
    orgToggleHierarchy: () => void
    highlightEdge: (nodeId: string) => void
    highlightEdgeHover: (nodeId: string) => void   // ✅ ADD
    unhighlightEdgeHover: (nodeId: string) => void  // ✅ ADD
  }
}

interface OrgNodeData {
  imageURL: string
  name: string
  nodeId: string
  hasChildren: boolean
  childrenLoaded: boolean
  isExpanded: boolean

  firstName?: string // ✅ ADD
  lastName?: string

  showTopArrow?: boolean
  nodeBGColor?: string

  designation?: string


  // realId:string
}

export interface ApexTreeNode {
  id: string
  data: OrgNodeData
  options: {
    nodeBGColor: string
    nodeBGColorHover: string
  }
  children: ApexTreeNode[]
  _hiddenChildren?: ApexTreeNode[]
}

@Component({
  selector: 'app-org-chart',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './org-chart.component.html',
  styleUrl: './org-chart.component.scss'
})
export class OrgChartComponent implements AfterViewInit, OnInit, OnDestroy {
  user: AuthState['user'] | null = null
  // user: AuthState['user'] | string = null
  private tree!: any
  private treeData!: any
  public apiEndpoint = environment.apiBaseUrl
  private destroy$ = new Subject<void>()
  private loadingNodes = new Set<string>()
  private edgeObserver: MutationObserver | null = null

  private showHierarchyView = false
  private originalData: any
  private allowHierarchyToggle = false
  private hasManager = false
  private isAdminUser = false
  private readonly defaultAvatar = `data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIj48Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSI1MCIgZmlsbD0iI2UwZTBlMCIvPjxjaXJjbGUgY3g9IjUwIiBjeT0iMzgiIHI9IjE4IiBmaWxsPSIjOWU5ZTllIi8+PGVsbGlwc2UgY3g9IjUwIiBjeT0iODUiIHJ4PSIzMCIgcnk9IjIyIiBmaWxsPSIjOWU5ZTllIi8+PC9zdmc+`
  private selectedNodeId: string | null = null;


  constructor(
    private orgChartService: OrgChartService,
    private store: Store
  ) { }

  // ================= LIFECYCLE =================

  // ngOnInit(): void {
  //   this.store.select(selectUser)
  //     .pipe(takeUntil(this.destroy$))
  //     .subscribe(user => { this.user = user })

  //   window.orgToggleNode = (nodeId: string) => {
  //     this.toggleNode(nodeId)
  //   }
  // }

  ngOnInit(): void {
    this.store
      .select(selectUser)
      .pipe(takeUntil(this.destroy$))
      .subscribe(user => {
        this.user = user
      })

    window.orgToggleNode = (nodeId: string) => {
      this.toggleNode(nodeId)
    }

    window.highlightEdge = (nodeId: string) => {
      this.highlightEdge(nodeId);
    };

    // console.log("FULL USER:", this.user)

    // ✅ NEW
    window.orgToggleHierarchy = () => {
      this.toggleHierarchyView()
    }

    window.highlightEdgeHover = (nodeId: string) => {
      this.setEdgeHoverColor(nodeId, true)
    }

    window.unhighlightEdgeHover = (nodeId: string) => {
      this.setEdgeHoverColor(nodeId, false)
    }
  }

  ngOnDestroy(): void {
    delete (window as any).orgToggleNode
    this.edgeObserver?.disconnect()
    this.destroy$.next()
    this.destroy$.complete()
  }

  // ngAfterViewInit(): void {
  //   this.store.select(selectUser)
  //     .pipe(takeUntil(this.destroy$))
  //     .subscribe(user => {
  //       if (!user) return

  //       this.orgChartService.getOrgHierarchy(user.id)
  //         .pipe(takeUntil(this.destroy$))
  //         .subscribe({
  //           next: (data: any) => {
  //             const isAdmin = typeof this.user === 'object' && this.user !== null && (this.user as any).role === 'admin'

  //             if (isAdmin) {
  //               // ✅ Admin: no filtering — sees the entire org tree
  //               this.treeData = this.prepareTreeData(data)
  //             } else {
  //               // 🔒 Employee: parent + siblings (no sibling children) + own children
  //               const filtered = this.filterTreeForEmployee(data, this.user!.id)
  //               console.log("this is my data ",data);
  //               console.log("this is my filtered data ",filtered);

  //               this.treeData = this.prepareTreeData(filtered)
  //             }

  //             setTimeout(() => {
  //               this.initializeTree()
  //               this.colorEdgesAfterRender()
  //               this.fixForeignObjectOverflow()
  //             }, 0)
  //           }
  //         })

  //     })
  // }

  ngAfterViewInit(): void {
    this.store
      .select(selectUser)
      .pipe(takeUntil(this.destroy$))
      .subscribe(user => {
        if (!user) return
        this.user = user
        this.orgChartService
          .getOrgHierarchy(user.id)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (data: any) => {
              // ✅ store original tree
              this.originalData = data

              // this code is add by shivam
              const hasManager = !!this.findRawParent(data, this.user!.id, null)
              console.log("has manager ? ", hasManager);

              this.hasManager = hasManager

              const isAdmin =
                typeof this.user === 'object' &&
                this.user !== null &&
                (this.user as any).role?.toLowerCase() === 'admin'


              // ✅ THIS IS THE REAL CONTROL
              this.allowHierarchyToggle = !isAdmin

              if (isAdmin) {
                this.treeData = this.prepareTreeData(data)

                // this.treeData = this.prepareShallowTree(data, true)
              } else {
                // ✅ DEFAULT VIEW → only employee + children
                const selfNode = this.findRawNode(data, this.user!.id)

                // this.treeData = this.prepareTreeData({
                //   ...selfNode,
                //   hasChildren: !!selfNode?.children?.length
                // })
                this.treeData = this.prepareTreeData(selfNode)
              }

              setTimeout(() => {
                this.initializeTree()
                this.colorEdgesAfterRender()
                this.fixForeignObjectOverflow()
              }, 0)
            }
          })
      })
  }

  getInitials(firstName: string = '', lastName: string = ''): string {
    const first = firstName?.trim()?.charAt(0)?.toUpperCase() || ''
    const last = lastName?.trim()?.charAt(0)?.toUpperCase() || ''

    return first + last || first || '?'
  }

  private checkIsAdmin(): boolean {
    if (!this.user) return false

    const role = (this.user as any)?.role

    if (!role) return false

    const normalized = String(role).toLowerCase().trim()

    return normalized === 'admin' || normalized === 'role_admin'
  }


  // new method for showing only one level 
  /**
 * Prepares root node + ONE level of children only.
 * Children that have sub-children get hasChildren=true
 * but their children array is EMPTY (lazy loaded on click).
 */

  // private toggleHierarchyView(): void {
  //   if (!this.originalData || !this.user) return

  //   this.showHierarchyView = !this.showHierarchyView

  //   if (this.showHierarchyView) {
  //     // ✅ SHOW parent + siblings
  //     const filtered = this.filterTreeForEmployee(this.originalData, this.user.id)
  //     this.treeData = this.prepareTreeData(filtered)
  //   } else {
  //     // ✅ BACK to self + children
  //     const selfNode = this.findRawNode(this.originalData, this.user.id)

  //     this.treeData = this.prepareTreeData({
  //       ...selfNode,
  //       hasChildren: !!selfNode?.children?.length
  //     })
  //   }

  //   this.tree.render(this.treeData)
  //   this.colorEdgesAfterRender()
  //   this.fixForeignObjectOverflow()
  // }


  // 


  // private highlightEdge(nodeId: string): void {
  //   this.selectedNodeId = nodeId;

  //   const container = document.getElementById('svg-tree');
  //   if (!container) return;

  //   const svg = container.querySelector('svg');
  //   if (!svg) return;

  //   svg.querySelectorAll<SVGPathElement>('path').forEach(path => {
  //     path.setAttribute('stroke', '#BFC9D1');
  //     path.setAttribute('stroke-width', '2');
  //     path.style.setProperty('stroke', '#BFC9D1', 'important');
  //   });

  //   svg.querySelectorAll<SVGPathElement>('path').forEach(path => {
  //     const id = path.getAttribute('id');
  //     if (!id) return;

  //     if (id.endsWith(nodeId)) {
  //       path.setAttribute('stroke', '#FF6B6B');
  //       path.setAttribute('stroke-width', '4');
  //       path.style.setProperty('stroke', '#FF6B6B', 'important');
  //     }
  //   });
  // }

  private highlightEdge(nodeId: string): void {
    const container = document.getElementById('svg-tree')
    if (!container) return

    const svg = container.querySelector('svg')
    if (!svg) return

    this.edgeObserver?.disconnect()

    //Reset all edges
    svg.querySelectorAll<SVGPathElement>('path').forEach(path => {
      path.setAttribute('stroke', '#BFC9D1')
      path.setAttribute('stroke-width', '2')
      path.style.cssText += ';stroke:#BFC9D1!important;stroke-width:2px!important;'
    })

    if (this.selectedNodeId === nodeId) {
      this.selectedNodeId = null
      return
    }

    this.selectedNodeId = nodeId

    svg.querySelectorAll<SVGPathElement>('path').forEach(path => {
      const id = path.getAttribute('id')
      if (!id) return

      const matched = this.pathIdContainsNode(id, nodeId)
      if (!matched) return


      path.parentNode?.appendChild(path)

      path.setAttribute('stroke', '#FF6B6B')
      path.setAttribute('stroke-width', '4')

      path.style.cssText += ';stroke:#FF6B6B!important;stroke-width:4px!important;'


      // path.style.setProperty('stroke', '#FF6B6B', 'important')
      // path.style.setProperty('stroke-width', '4', 'important')
      // path.style.setProperty('filter', 'none', 'important')

      // path.style.stroke = '#FF6B6B'
      // path.style.strokeWidth = '4px'
    })

  }

  // private setEdgeHoverColor(nodeId: string, isHover: boolean): void {
  //   const container = document.getElementById('svg-tree')
  //   if (!container) return

  //   const svg = container.querySelector('svg')
  //   if (!svg) return

  //   this.edgeObserver?.disconnect()

  //   svg.querySelectorAll<SVGPathElement>('path').forEach(path => {
  //     const id = path.getAttribute('id')
  //     if (!id) return

  //     // ✅ Match if nodeId appears as EITHER parent OR child segment in the path id
  //     const matched = this.pathIdContainsNode(id, nodeId)
  //     if (!matched) return

  //     if (this.selectedNodeId === nodeId) return

  //     if (isHover) {
  //       // path.setAttribute('stroke', '#FF6B6B')
  //       // path.setAttribute('stroke-width', '3')
  //       // path.style.cssText += ';stroke:#FF6B6B!important;stroke-width:3px!important;'

  //       path.parentNode?.appendChild(path)
  //       path.style.setProperty('stroke', '#FF6B6B', 'important')

  //       // path.style.setProperty('stroke', '#FF6B6B', 'important')
  //       // path.style.setProperty('stroke-width', '3', 'important')
  //       // path.style.setProperty('opacity', '1', 'important')

  //       // // ❌ Kill gray overlay completely
  //       // path.style.setProperty('mix-blend-mode', 'normal')


  //     } else {
  //       path.setAttribute('stroke', '#BFC9D1')
  //       path.setAttribute('stroke-width', '2')
  //       path.style.cssText += ';stroke:#BFC9D1!important;stroke-width:2px!important;'
  //     }
  //   })

  // }

private hoverNodeId: string | null = null
private hoverResetTimer: any = null

private setEdgeHoverColor(nodeId: string, isHover: boolean): void {
  const container = document.getElementById('svg-tree')
  if (!container) return
  const svg = container.querySelector('svg')
  if (!svg) return

  this.edgeObserver?.disconnect()

  if (isHover) {
    // ✅ Cancel any pending reset for the SAME node
    if (this.hoverResetTimer && this.hoverNodeId === nodeId) {
      clearTimeout(this.hoverResetTimer)
      this.hoverResetTimer = null
    }

    this.hoverNodeId = nodeId

    //  Reset ALL paths to grey first
    svg.querySelectorAll<SVGPathElement>('path').forEach(path => {
      // Don't reset the selected (clicked) node's edges
      const id = path.getAttribute('id')
      if (!id) return
      if (this.selectedNodeId && this.pathIdContainsNode(id, this.selectedNodeId)) return

      path.setAttribute('stroke', '#BFC9D1')
      path.setAttribute('stroke-width', '2')
      path.style.cssText += ';stroke:#BFC9D1!important;stroke-width:2px!important;'
    })

    
    svg.querySelectorAll<SVGPathElement>('path').forEach(path => {
      const id = path.getAttribute('id')
      if (!id) return
      if (!this.pathIdContainsNode(id, nodeId)) return
      if (this.selectedNodeId === nodeId) return

      path.parentNode?.appendChild(path) // bring to front
      path.setAttribute('stroke', '#FF6B6B')
      path.setAttribute('stroke-width', '2')
      path.style.cssText += ';stroke:#FF6B6B!important;stroke-width:2px!important;'
    })

   
    if (this.selectedNodeId && this.selectedNodeId !== nodeId) {
      svg.querySelectorAll<SVGPathElement>('path').forEach(path => {
        const id = path.getAttribute('id')
        if (!id) return
        if (!this.pathIdContainsNode(id, this.selectedNodeId!)) return

        path.parentNode?.appendChild(path)
        path.setAttribute('stroke', '#FF6B6B')
        path.setAttribute('stroke-width', '4')
        path.style.cssText += ';stroke:#FF6B6B!important;stroke-width:4px!important;'
      })
    }

  } else {
    // ✅ On mouse leave - delayed reset
    this.hoverNodeId = null

    this.hoverResetTimer = setTimeout(() => {
      // If another node is now hovered, skip reset
      if (this.hoverNodeId) return

      svg.querySelectorAll<SVGPathElement>('path').forEach(path => {
        const id = path.getAttribute('id')
        if (!id) return

      
        if (this.selectedNodeId && this.pathIdContainsNode(id, this.selectedNodeId)) {
          path.parentNode?.appendChild(path)
          path.setAttribute('stroke', '#FF6B6B')
          path.setAttribute('stroke-width', '4')
          path.style.cssText += ';stroke:#FF6B6B!important;stroke-width:4px!important;'
          return
        }

        // Reset everything else to grey
        path.setAttribute('stroke', '#BFC9D1')
        path.setAttribute('stroke-width', '2')
        path.style.cssText += ';stroke:#BFC9D1!important;stroke-width:2px!important;'
      })

      this.hoverResetTimer = null
    }, 50)
  }
}



  private pathIdContainsNode(pathId: string, nodeId: string): boolean {
    const pathParts = pathId.split('-')
    const nodeParts = nodeId.split('-')
    const nodeLen = nodeParts.length  // 5 for UUID, 6 for n-prefixed

    // Slide a window of nodeLen across pathId parts
    for (let start = 0; start <= pathParts.length - nodeLen; start++) {
      const candidate = pathParts.slice(start, start + nodeLen).join('-')
      if (candidate === nodeId) return true
    }

    return false
  }
  private toggleHierarchyView(): void {
    if (!this.originalData || !this.user) return

    this.showHierarchyView = !this.showHierarchyView

    if (this.showHierarchyView) {
      const filtered = this.filterTreeForEmployee(this.originalData, this.user.id)
      this.treeData = this.prepareTreeData(filtered)
    } else {
      const selfNode = this.findRawNode(this.originalData, this.user.id)
      // ✅ Pass selfNode directly, depth=0 will show employee + one level
      this.treeData = this.prepareTreeData(selfNode)
    }

    this.tree.render(this.treeData)
    this.colorEdgesAfterRender()
    this.fixForeignObjectOverflow()
  }

  private initializeTree(): void {
    const container = document.getElementById('svg-tree')
    if (!container) return

    container.innerHTML = ''

    this.tree = null

    // ✅ CRITICAL: Set strict container bounds
    Object.assign(container.style, {
      // width: '80vw',
      height: '80vh',
      overflow: 'hidden',
      position: 'relative'
      // border: '1px solid black'
      // background: '#FCF9EA'
    })

    const options: any = {
      contentKey: 'data',
      // width: '80vw',
      height: '80vh',

      // nodeWidth: 220,
      // nodeHeight: 90,

      nodeWidth: 250,
      nodeHeight: 120,

      // childrenSpacing: 50,
      // siblingSpacing: 20,
      childrenSpacing: 85,
      siblingSpacing: 15,
      direction: 'top',
      enableExpandCollapse: false,
      enableToolbar: true,
      // canvasStyle: 'border:1px solid black;background:#FCF9EA; ',
      nodeTemplate: (node: OrgNodeData) => this.buildNodeTemplate(node)
    }

    this.tree = new ApexTree(container, options)
    this.tree.render(this.treeData)

    // setTimeout(() => {
    //   const svg = document.querySelector('#svg-tree svg');
    //   if (!svg) return;
    //   console.log('=== ALL PATHS ===');
    //   svg.querySelectorAll('path').forEach(p => {
    //     console.log('PATH ID:', p.getAttribute('id'));
    //   });
    //   console.log('=== ALL G TAGS ===');
    //   svg.querySelectorAll('g').forEach(g => {
    //     console.log('G attrs:', g.getAttributeNames().map(a => `${a}="${g.getAttribute(a)}"`).join(' '));
    //   });
    //   console.log('=== TREE DATA ===', JSON.stringify(this.treeData, null, 2));
    // }, 500);
  }

  // ================= NODE TEMPLATE =================

  private buildNodeTemplate(node: OrgNodeData): string {
    const imageUrl = this.resolveImageUrl(node.imageURL)


    // ✅ Fallback: if firstName/lastName missing, split from name
    const firstName = node.firstName || node.name?.split(' ')[0] || ''
    const lastName = node.lastName || node.name?.split(' ').slice(1).join(' ') || ''
    const initials = this.getInitials(firstName, lastName)
    const designations = node.designation
    // console.log("designation", designations);


    const imgId = `img-${node.nodeId}`
    const fbId = `fb-${node.nodeId}`

    const avatarHtml = (imageUrl && imageUrl !== this.defaultAvatar)
      ? `
        <img
          id="${imgId}"
          src="${imageUrl}"
          onerror="
            var i=document.getElementById('${imgId}');
            var f=document.getElementById('${fbId}');
            if(i) i.style.display='none';
            if(f){ f.style.display='flex'; }
          "
          style="
            width: 50px;
            height: 50px;
            border-radius: 50%;
            object-fit: cover;

            display: block;
            flex-shrink: 0;
            border: 4px solid #ffffff;
            box-shadow: 0 2px 6px rgba(0,0,0,0.15);
          "
        />
        <div
          id="${fbId}"
          style="
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background: #FF6B6B;
            color: white;
            display: none;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            font-size: 16px;

            flex-shrink: 0;
             border: 4px solid #ffffff;
            box-shadow: 0 2px 6px rgba(0,0,0,0.15);
          "
        >${initials}</div>`
      : `<div style="
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background: #FF6B6B;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 16px;

          flex-shrink: 0;
        ">${initials}</div>`

    const topArrow = `
      <div onclick="event.stopPropagation(); window.orgToggleHierarchy()"
        style="
          position: absolute;
          top: -18px;
          left: 50%;
          transform: translateX(-50%);
          width: 28px;
          height: 28px;
          min-height:22px;
          border-radius: 50%;
          background: #374151;
          border: 2px solid #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          z-index: 9999;
        "
      >
        <i class="${this.showHierarchyView ? 'ti ti-minus' : 'ti ti-plus'}"
          style="font-size: 14px; color: #fff;">
        </i>
      </div>
    `

  

    const expandButton = node.hasChildren
      ? `
  <div onclick="event.stopPropagation(); window.orgToggleNode('${node.nodeId}')"
    style="
      position: absolute;
      bottom: -16px;
      left: 50%;
      transform: translateX(-50%);
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: #374151;
      border: 2.5px solid #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 9999;
    "
  >
    <i class="${node.isExpanded ? 'ti ti-minus' : 'ti ti-plus'}"
      style="font-size: 18px; color: #fffbfb; z-index:10;">
    </i>
  </div>`
      : ''

    return `
  <div 
    data-node-id="${node.nodeId}"
    data-node-color="${node.nodeBGColor || ''}"
    onclick="window.highlightEdge('${node.nodeId}')"
    onmouseenter="window.highlightEdgeHover('${node.nodeId}')"
    onmouseleave="window.unhighlightEdgeHover('${node.nodeId}')"
    style="
      position: relative;
      display: flex;
      z-index: 10;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      gap: 10px;
      width: 100%;
      
      height: auto;
      
      min-height: 106px;
     
  
      padding: 10px 14px;
      overflow: visible;
      border-radius: 20px;
      background: linear-gradient(135deg, #f5f5f5, #e0e0e0);
    "
  >
    ${node.showTopArrow ? topArrow : ''}

    ${avatarHtml}

    <div style="
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      flex: 1;
      min-width: 0;
      overflow: visible;
    ">
 <div style="
  font-size: 14px;
  font-weight: 600;
  color: #0a0909;
   white-space: normal;
word-break: break-word;
overflow-wrap: anywhere;
  max-width: 130px;
  line-height: 1.3;
">
        ${node.name}
      </div>

      ${node.designation ? `
      <div style="
        font-size: 11px;
        font-weight: 400;

        color: #28396C;
        margin-top: 2px;
          white-space: normal;         
  word-break: break-word;      
  overflow-wrap: anywhere;
        line-height: 1.3;
      ">
        ${node.designation}
      </div>` : ''}
    </div>

    ${expandButton}
  </div>
  `
  }



  // ================= TOGGLE / EXPAND =================
  private sanitizeId(id: string): string {
    // CSS selectors cannot start with a digit — prefix with 'n-'
    return /^\d/.test(id) ? `n-${id}` : id
  }

  private desanitizeId(sanitizedId: string): string {
    return sanitizedId.startsWith('n-') ? sanitizedId.slice(2) : sanitizedId
  }
  // private toggleNode(nodeId: string): void {
  //   const node = this.findNode(this.treeData, nodeId)
  //   if (!node) return

  //   if (!node.data.childrenLoaded) {
  //     this.loadChildren(nodeId)
  //     return
  //   }


  //   node.data.isExpanded = !node.data.isExpanded

  //   if (!node.data.isExpanded) {
  //     node._hiddenChildren = node.children
  //     node.children = []
  //   } else {
  //     node.children = node._hiddenChildren || []
  //   }

  //   this.tree.render(this.treeData)
  //   this.colorEdgesAfterRender()
  //   this.fixForeignObjectOverflow()
  // }



  private toggleNode(nodeId: string): void {
    const node = this.findNode(this.treeData, nodeId)
    if (!node) return

    if (!node.data.childrenLoaded) {
      this.loadChildren(nodeId)
      return
    }

    const isCurrentlyExpanded = node.children && node.children.length > 0


    if (isCurrentlyExpanded) {
      node._hiddenChildren = [...node.children]
      node.children = []
      node.data.isExpanded = false

    } else {
      node.children = node._hiddenChildren || []
      node._hiddenChildren = []
      node.data.isExpanded = true

    }



    this.treeData = { ...this.treeData }
    this.tree.render(this.treeData)
    this.colorEdgesAfterRender()
    this.fixForeignObjectOverflow()
  }


  // private loadChildren(nodeId: string): void {
  //   if (this.loadingNodes.has(nodeId)) return
  //   this.loadingNodes.add(nodeId)

  //   const parentNode = this.findNode(this.treeData, nodeId)
  //   const parentColor = parentNode?.options?.nodeBGColor

  //   this.orgChartService
  //     .getChildren(nodeId)
  //     .pipe(takeUntil(this.destroy$))
  //     .subscribe({
  //       next: (children: any) => {
  //         this.loadingNodes.delete(nodeId)

  //         const parent = this.findNode(this.treeData, nodeId)
  //         if (!parent) return

  //         // ✅🔥 FILTER DISABLED USERS HERE (MOST IMPORTANT FIX)
  //         const validChildren = (children || []).filter(
  //           (c: any) => !c?.disabled && c?.disabled !== 'true'
  //         )

  //         console.log('✅ FILTERED CHILDREN:', validChildren)

  //         const prepared = validChildren.map((c: any) => this.prepareTreeData(c, parentColor))

  //         parent.children = prepared
  //         parent.data.childrenLoaded = true
  //         parent.data.isExpanded = true

  //         this.tree.render(this.treeData)
  //         this.colorEdgesAfterRender()
  //         this.fixForeignObjectOverflow()
  //       }
  //     })
  // }



  private loadChildren(nodeId: string): void {
    if (this.loadingNodes.has(nodeId)) return
    this.loadingNodes.add(nodeId)

    const parentNode = this.findNode(this.treeData, nodeId)
    const parentColor = parentNode?.options?.nodeBGColor



    const realId = this.desanitizeId(nodeId)  

    this.orgChartService
      .getChildren(realId)  
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (children: any) => {
          this.loadingNodes.delete(nodeId)

          const parent = this.findNode(this.treeData, nodeId)
          if (!parent) return

          const validChildren = (children || []).filter(
            (c: any) => !c?.disabled && c?.disabled !== 'true'
          )

          const prepared = validChildren.map((c: any) => this.prepareTreeData(c, parentColor))

          parent.children = prepared
          parent.data.childrenLoaded = true
          parent.data.isExpanded = true

          this.tree.render(this.treeData)
          this.colorEdgesAfterRender()
          this.fixForeignObjectOverflow()
        }


      })
  }

  // ================= VISIBILITY RESTRICTION =================

  /**
   * ADMIN  → this method is never called; full tree is rendered as-is.
   *
   * EMPLOYEE visibility rules:
   *   ✅ Parent              — card shown, no expand button (cannot go further up)
   *   ✅ Siblings            — card shown, no expand button (their children hidden)
   *   ✅ Own children        — expandable; grandchildren also load normally
   *   ❌ Grandparent         — not visible
   *   ❌ Children of siblings — not visible
   */

  private filterTreeForEmployee(root: any, userId: string): any {
    const parentNode = this.findRawParent(root, userId, null)
    // console.log("parent node", parentNode);
    // console.log("root", root);
    // console.log("user", userId);

    if (!parentNode) {
      const userNode = this.findRawNode(root, userId)
      if (!userNode) return root

      return {
        ...userNode,
        hasChildren: !!userNode.hasChildren,
        isSelf: true // ✅ mark self
      }
    }

    return {
      ...parentNode,
      hasChildren: false,
      children: (parentNode.children || []).map((node: any) => {
        // ✅ SELF
        if (String(node.id) === String(userId)) {
          return {
            ...node,
            isSelf: true, // ✅ IMPORTANT
            hasChildren: !!node.hasChildren
          }
        }

        // ❌ SIBLINGS
        return {
          ...node,
          isSelf: false,
          hasChildren: false, // no expand button
          children: []
        }
      })
    }
  }

  /** Recursively finds a node by id in the raw (un-prepared) API tree */
  // private findRawNode(node: any, id: string): any | null {
  //   if (node.id === id) return node
  //   for (const child of node.children || []) {
  //     const found = this.findRawNode(child, id)
  //     if (found) return found
  //   }
  //   return null
  // }

  private findRawNode(node: any, userId: string): any {
    if (!node) return null

    if (String(node.id) === String(userId)) {
      return node
    }

    const children = this.getChildren(node)
    // console.log('my children', children)

    for (const child of children) {
      const result = this.findRawNode(child, userId)
      if (result) return result
    }

    return null
  }
  /** Returns the direct parent of the target node, or null if it is the root */
  // private findRawParent(node: any, id: string, parent: any): any | null {
  //   if (node.id === id) return parent
  //   for (const child of node.children || []) {
  //     const found = this.findRawParent(child, id, node)
  //     if (found !== undefined) return found
  //   }
  //   return undefined as any
  // }

  // ================= DATA PREP =================

  private getChildren(node: any): any[] {
    if (!node) return []

    // console.log("My node",node);
    if (Array.isArray(node.children)) return node.children

    if (node.data && Array.isArray(node.data.children)) {
      return node.data.children
    }

    return []
  }

  private findRawParent(node: any, userId: string, parent: any): any {
    if (!node) return null

    if (String(node.id) === String(userId)) {
      return parent
    }

    for (const child of node.children || []) {
      const result = this.findRawParent(child, userId, node)
      if (result) return result
    }

    return null
  }

  // private prepareTreeData(node: any, parentColor?: string): ApexTreeNode {
  //   const color = this.getDifferentColor(parentColor)

  //   // ✅ Filter only active (non-disabled) children
  //   const validChildren = (node.children || []).filter(
  //     (child: any) => String(child?.disabled) !== 'true'
  //   )

  //   const hasChildren = validChildren.length > 0
  //   const childrenLoaded = validChildren.length > 0

  //   // ✅ Safe name handling
  //   const firstName = node.firstName || node.data?.firstName || ''
  //   const lastName = node.lastName || node.data?.lastName || ''
  //   const fullName = node.data?.name || `${firstName} ${lastName}`.trim() || 'Unknown'

  //   const imageURL =
  //     node.picture ||
  //     node.image ||
  //     node.imageURL ||
  //     node.avatar ||
  //     node.profilePic ||
  //     node.photo ||
  //     node.data?.picture ||
  //     node.data?.imageURL ||
  //     node.data?.image ||
  //     ''

  //   const isSelf = String(node.id) === String(this.user?.id)
  //   const isAdmin = String(this.user?.email).toLowerCase() === 'contact@avrtechno.com'

  //   const prepared: ApexTreeNode = {
  //     id: node.id,
  //     data: {
  //       name: fullName,
  //       imageURL: imageURL,
  //       firstName: firstName, // ✅ direct from API
  //       lastName: lastName, // ✅ direct from API
  //       nodeId: node.id,

  //       hasChildren: !!node.hasChildren,
  //       childrenLoaded,
  //       isExpanded: childrenLoaded,
  //       showTopArrow: isSelf && this.hasManager,
  //       nodeBGColor: color,
  //       // showTopArrow: isSelf && !isAdmin
  //     },
  //     options: {
  //       nodeBGColor: color,
  //       nodeBGColorHover: color + 'CC',
  //     },
  //     children: []
  //   }

  //   // ✅ Recursively process ONLY valid children
  //   if (hasChildren) {
  //     prepared.children = validChildren.map((child: any) => this.prepareTreeData(child, color))
  //   }

  //   if (childrenLoaded) {
  //     prepared.children = node.children.map((c: any) => this.prepareTreeData(c, color))
  //   }

  //   return prepared
  // }


  // private prepareTreeData(node: any, parentColor?: string): ApexTreeNode {
  //   const color = this.getDifferentColor(parentColor)
  //   const safeId = this.sanitizeId(node.id)  // ✅ sanitize here

  //   const validChildren = (node.children || []).filter(
  //     (child: any) => String(child?.disabled) !== 'true'
  //   )

  //   const hasChildren = validChildren.length > 0
  //   const childrenLoaded = validChildren.length > 0
  //   // const childrenLoaded = false

  //   const firstName = node.firstName || node.data?.firstName || ''
  //   const lastName = node.lastName || node.data?.lastName || ''
  //   const fullName = node.data?.name || `${firstName} ${lastName}`.trim() || 'Unknown'

  //   const imageURL =
  //     node.picture || node.image || node.imageURL || node.avatar ||
  //     node.profilePic || node.photo ||
  //     node.data?.picture || node.data?.imageURL || node.data?.image || ''

  //   const isSelf = String(node.id) === String(this.user?.id)

  //   const prepared: ApexTreeNode = {
  //     id: safeId,  // ✅ use sanitized ID
  //     data: {
  //       name: fullName,
  //       imageURL: imageURL,
  //       firstName,
  //       lastName,
  //       nodeId: safeId,  // ✅ use sanitized ID (used in toggleNode button)
  //       hasChildren: !!node.hasChildren,
  //       childrenLoaded,
  //       isExpanded: childrenLoaded,
  //       showTopArrow: isSelf && this.hasManager,
  //       nodeBGColor: color,
  //     },
  //     options: {
  //       nodeBGColor: color,
  //       nodeBGColorHover: color + 'CC',
  //     },
  //     children: []
  //   }

  //   if (hasChildren) {
  //     prepared.children = validChildren.map((child: any) => this.prepareTreeData(child, color))
  //   }



  //   if (childrenLoaded) {
  //     prepared.children = node.children.map((c: any) => this.prepareTreeData(c, color))
  //   }

  //   return prepared
  // }



  // private prepareTreeData(node: any, parentColor?: string, depth: number = 0): ApexTreeNode {
  //   // const color = this.getDifferentColor(parentColor)
  //   const color = this.getDifferentColor()
  //   const safeId = this.sanitizeId(node.id)

  //   const validChildren = (node.children || []).filter(
  //     (child: any) => String(child?.disabled) !== 'true'
  //   )

  //   const hasChildren = validChildren.length > 0

  //   const firstName = node.firstName || node.data?.firstName || ''
  //   const lastName = node.lastName || node.data?.lastName || ''
  //   const fullName = node.data?.name || `${firstName} ${lastName}`.trim() || 'Unknown'

  //   const imageURL =
  //     node.picture || node.image || node.imageURL || node.avatar ||
  //     node.profilePic || node.photo ||
  //     node.data?.picture || node.data?.imageURL || node.data?.image || ''

  //   const isSelf = String(node.id) === String(this.user?.id)

  //   const prepared: ApexTreeNode = {
  //     id: safeId,
  //     data: {
  //       name: fullName,
  //       imageURL,
  //       firstName,
  //       lastName,
  //       nodeId: safeId,
  //       hasChildren: hasChildren || !!node.hasChildren,
  //       // ✅ Only mark as loaded if we're at depth 0 (employee itself)
  //       // Children at depth 1 are shown but their children are NOT loaded
  //       childrenLoaded: depth === 0 ? hasChildren : false,
  //       isExpanded: depth === 0 ? hasChildren : false,
  //       showTopArrow: isSelf && this.hasManager,
  //       nodeBGColor: color,
  //     },
  //     options: {
  //       nodeBGColor: color,
  //       nodeBGColorHover: color + 'CC',
  //     },
  //     children: []
  //   }

  //   // ✅ Only expand ONE level deep
  //   if (hasChildren && depth === 0) {
  //     prepared.children = validChildren.map((child: any) =>
  //       this.prepareTreeData(child, color, depth + 1)  // depth=1, so their children won't load
  //     )
  //   }

  //   return prepared
  // }

  // private prepareTreeData(node: any, parentColor?: string, depth: number = 0): ApexTreeNode {
  //   const color = this.getDifferentColor()
  //   const safeId = this.sanitizeId(node.id)

  //   const validChildren = (node.children || []).filter(
  //     (child: any) => String(child?.disabled) !== 'true'
  //   )

  //   const hasChildren = validChildren.length > 0

  //   const firstName = node.firstName || node.data?.firstName || ''
  //   const lastName = node.lastName || node.data?.lastName || ''
  //   const fullName =
  //     node.data?.name || `${firstName} ${lastName}`.trim() || 'Unknown'

  //   const imageURL =
  //     node.picture || node.image || node.imageURL || node.avatar ||
  //     node.profilePic || node.photo ||
  //     node.data?.picture || node.data?.imageURL || node.data?.image || ''

  //   const isSelf = String(node.id) === String(this.user?.id)

  //   const prepared: ApexTreeNode = {
  //     id: safeId,
  //     data: {
  //       name: fullName,
  //       imageURL,
  //       firstName,
  //       lastName,
  //       nodeId: safeId,

  //       // ✅ IMPORTANT
  //       hasChildren: hasChildren || !!node.hasChildren,

  //       // ❗ ALWAYS FALSE → force lazy loading
  //       childrenLoaded: false,

  //       // ❗ collapsed by default
  //       isExpanded: false,

  //       showTopArrow: isSelf && this.hasManager,
  //       nodeBGColor: color,
  //     },
  //     options: {
  //       nodeBGColor: color,
  //       nodeBGColorHover: color + 'CC',
  //     },
  //     children: []
  //   }

  //   // ✅ ONLY render 1st level
  //   if (depth === 0 && hasChildren) {
  //     prepared.children = validChildren.map((child: any) =>
  //       this.prepareTreeData(child, color, depth + 1)
  //     )
  //   }

  //   return prepared
  // }


  private prepareTreeData(node: any, parentColor?: string, depth: number = 0): ApexTreeNode {
    const color = this.getDifferentColor()
    const safeId = this.sanitizeId(node.id)

    const validChildren = (node.children || []).filter(
      (child: any) => String(child?.disabled) !== 'true'
    )

    const hasChildren = validChildren.length > 0

    const firstName = node.firstName || node.data?.firstName || ''
    const lastName = node.lastName || node.data?.lastName || ''
    const fullName = node.data?.name || `${firstName} ${lastName}`.trim() || 'Unknown'

    const imageURL =
      node.picture || node.image || node.imageURL || node.avatar ||
      node.profilePic || node.photo ||
      node.data?.picture || node.data?.imageURL || node.data?.image || ''

    // ✅ ADD THIS LINE
    const designation = node.data?.designation || node.designation || ''

    const isSelf = String(node.id) === String(this.user?.id)

    // const prepared: ApexTreeNode = {
    //   id: safeId,
    //   data: {
    //     name: fullName,
    //     imageURL,
    //     firstName,
    //     lastName,
    //     nodeId: safeId,
    //     designation, 
    //     hasChildren: hasChildren || !!node.hasChildren,
    //     childrenLoaded: false,
    //     isExpanded: false,
    //     showTopArrow: isSelf && this.hasManager,
    //     nodeBGColor: color,
    //   },
    //   options: {
    //     nodeBGColor: color,
    //     nodeBGColorHover: color + 'CC',
    //   },
    //   children: []
    // }

    const prepared: ApexTreeNode = {
      id: safeId,
      data: {
        name: fullName,
        imageURL,
        firstName,
        lastName,
        nodeId: safeId,
        designation,
        hasChildren: hasChildren || !!node.hasChildren,
        childrenLoaded: depth === 0 && hasChildren ? true : false,
        isExpanded: depth === 0 && hasChildren ? true : false,
        showTopArrow: isSelf && this.hasManager,
        nodeBGColor: color,
      },
      options: {
        nodeBGColor: color,
        nodeBGColorHover: color + 'CC',
      },
      children: []
    }

    if (depth === 0 && hasChildren) {
      prepared.children = validChildren.map((child: any) =>
        this.prepareTreeData(child, color, depth + 1)
      )
    }

    if (depth === 0 && hasChildren) {
      prepared.children = validChildren.map((child: any) =>
        this.prepareTreeData(child, color, depth + 1)
      )
    }

    return prepared
  }

  // ================= OVERFLOW FIX =================

  private fixForeignObjectOverflow(): void {
    setTimeout(() => {
      const container = document.getElementById('svg-tree')
      if (!container) return

      const svg = container.querySelector('svg')
      if (svg) {
        svg.style.overflow = 'visible'
        svg.setAttribute('overflow', 'visible')
      }

      container.querySelectorAll('foreignObject').forEach(fo => {
        fo.setAttribute('overflow', 'visible')
          ; (fo as unknown as HTMLElement).style.overflow = 'visible'
      })
    }, 60)
  }

  // ================= EDGE COLORING =================

  // private colorEdgesAfterRender(): void {
  //   setTimeout(() => {
  //     const container = document.getElementById('svg-tree')
  //     if (!container) return


  //     // private colorEdgesAfterRender(): void {
  //     //   setTimeout(() => {
  //     //     const container = document.getElementById('svg-tree')
  //     //     if (!container) return

  //     //     const svg = container.querySelector('svg')
  //     //     if (!svg) return

  //     //     this.edgeObserver?.disconnect()

  //     // ✅ Observe changes safely
  //     this.edgeObserver = new MutationObserver(mutations => {
  //       mutations.forEach(mutation => {
  //         const target = mutation.target as SVGPathElement

  //         //     // ✅ Apply colors initially
  //         //     this.applyEdgeColors(svg, colorMap)

  //         //     // ✅ Observe changes safely
  //         //     this.edgeObserver = new MutationObserver((mutations) => {
  //         //       mutations.forEach((mutation) => {
  //         //         const target = mutation.target as SVGPathElement

  //         //         if (target.tagName !== 'path') return

  //         //         const id = target.getAttribute('id')
  //         //         if (!id) return

  //         //         // ✅ SAFE extraction (no hardcoding)
  //         //         const parts = id.split('-')
  //         //         const parentId = parts[parts.length - 1]

  //         //         const color = colorMap.get(parentId)

  //         //         if (color && target.getAttribute('stroke') !== color) {
  //         //           target.setAttribute('stroke', color)
  //         //           target.setAttribute('stroke-width', '2')
  //         //         }
  //         //       })
  //         //     })

  //         //     this.edgeObserver.observe(svg, {
  //         //       subtree: true,
  //         //       attributes: true
  //         //       // ❌ removed attributeFilter restriction (safer)
  //         //     })


  //       }, 50)
  //     }


  // })
  // }



  //   private colorEdgesAfterRender(): void {
  //   setTimeout(() => {
  //     const container = document.getElementById('svg-tree');
  //     if (!container) return;

  //     const svg = container.querySelector('svg');
  //     if (!svg) return;

  //     this.edgeObserver?.disconnect();

  //     // ✅ Build map from treeData — child.id → parent's color
  //     const colorMap = new Map<string, string>();
  //     this.buildEdgeColorMapFromData(this.treeData, colorMap);

  //     const applyColors = () => {
  //       svg.querySelectorAll<SVGPathElement>('path').forEach((path) => {
  //         const id = path.getAttribute('id');
  //         if (!id) return;

  //         // Log once to inspect the real path id format
  //         // console.log('PATH ID:', id);

  //         const parts = id.split('-');

  //         // Try last segment first, then second-to-last
  //         const candidateIds = [parts[parts.length - 1], parts[parts.length - 2]];

  //         for (const candidateId of candidateIds) {
  //           const color = colorMap.get(candidateId);
  //           if (color) {
  //             path.setAttribute('stroke', color);
  //             path.setAttribute('stroke-width', '2');
  //             path.style.setProperty('stroke', color, 'important');
  //             break;
  //           }
  //         }
  //       });
  //     };

  //     applyColors();

  //     // Re-apply on any DOM change to prevent hover from resetting stroke
  //     this.edgeObserver = new MutationObserver(applyColors);
  //     this.edgeObserver.observe(svg, {
  //       subtree: true,
  //       attributes: true,
  //       attributeFilter: ['stroke'],
  //     });

  //   }, 150);
  // }



  // private buildEdgeColorMap(svg: SVGSVGElement): Map<string, string> {
  //   const colorMap = new Map<string, string>()
  //   svg.querySelectorAll<SVGGElement>('g[data-self]').forEach(g => {
  //     const nodeId = g.getAttribute('data-self')
  //     if (!nodeId) return
  //     const div = g.querySelector('foreignObject > div') as HTMLElement | null
  //     if (div) colorMap.set(nodeId, div.style.backgroundColor)
  //   })
  //   return colorMap
  // }


  private buildEdgeColorMapFromData(node: ApexTreeNode, map: Map<string, string>): void {
    for (const child of node.children || []) {
      // key = "parentId-childId" → value = parent's color
      map.set(`${node.id}-${child.id}`, node.options.nodeBGColor);
      this.buildEdgeColorMapFromData(child, map);
    }
  }

  //  private buildEdgeColorMapFromData(node: ApexTreeNode, map: Map<string, string>): void {
  //     for (const child of node.children || []) {
  //       // Edge connecting parent → child should have parent's color
  //       map.set(child.id, node.options.nodeBGColor);
  //       this.buildEdgeColorMapFromData(child, map);
  //     }
  //   }


  // this is the working code
  // private colorEdgesAfterRender(): void {
  //   setTimeout(() => {
  //     const container = document.getElementById('svg-tree');
  //     if (!container) return;

  //     const svg = container.querySelector('svg');
  //     if (!svg) return;

  //     this.edgeObserver?.disconnect();
  //     this.edgeObserver = null;

  //     const colorMap = new Map<string, string>();
  //     this.buildEdgeColorMapFromData(this.treeData, colorMap);

  //     svg.querySelectorAll<SVGPathElement>('path').forEach((path) => {
  //       const id = path.getAttribute('id');
  //       if (!id) return;

  //       const parts = id.split('-');
  //       const parentId = parts.slice(0, 5).join('-');
  //       const childId = parts.slice(5, 10).join('-');
  //       const key = `${parentId}-${childId}`;

  //       const color = colorMap.get(key);
  //       if (color) {
  //         path.setAttribute('stroke', color);
  //         path.setAttribute('stroke-width', '2');
  //         path.style.setProperty('stroke', color, 'important');
  //       }
  //     });

  //   }, 150);
  // }

  private colorEdgesAfterRender(): void {
    setTimeout(() => {
      const container = document.getElementById('svg-tree');
      if (!container) return;

      const svg = container.querySelector('svg');
      if (!svg) return;

      this.edgeObserver?.disconnect();
      this.edgeObserver = null;

      const colorMap = new Map<string, string>();
      this.buildEdgeColorMapFromData(this.treeData, colorMap);

      svg.querySelectorAll<SVGPathElement>('path').forEach((path) => {
        const id = path.getAttribute('id');
        if (!id) return;

        const color = this.resolveEdgeColor(id, colorMap);
        if (color) {


          path.setAttribute('stroke', '#BFC9D1')
          path.setAttribute('stroke-width', '2')
          path.style.setProperty('stroke', '#BFC9D1')
        }
      });

    }, 150);
  }




  // this code is usefull for edge styling 
  // private colorEdgesAfterRender(): void {
  //   setTimeout(() => {
  //     const container = document.getElementById('svg-tree');
  //     if (!container) return;

  //     const svg = container.querySelector('svg');
  //     if (!svg) return;

  //     svg.querySelectorAll<SVGPathElement>('path').forEach((path) => {
  //       const d = path.getAttribute('d');
  //       if (!d) return;

  //       // 👉 Extract coordinates
  //       const nums = d.match(/[\d.]+/g)?.map(Number);
  //       if (!nums || nums.length < 4) return;

  //       const x1 = nums[0];
  //       const y1 = nums[1];
  //       const x2 = nums[nums.length - 2];
  //       const y2 = nums[nums.length - 1];

  //       const midY = (y1 + y2) / 2;

  //       // 🔥 BEST LOOK (smooth vertical curve)
  //       const smoothPath = `
  //         M ${x1} ${y1}
  //         C ${x1} ${midY}, ${x2} ${midY}, ${x2} ${y2}
  //       `;

  //       // ✅ Apply path
  //       path.setAttribute('d', smoothPath.trim());

  //       // 🎨 Style
  //       path.setAttribute('stroke', '#44ACFF');
  //       path.setAttribute('stroke-width', '2');
  //       path.setAttribute('fill', 'none');

  //       // ✨ Smooth edges
  //       path.setAttribute('stroke-linecap', 'round');
  //       path.setAttribute('stroke-linejoin', 'round');

  //       // Soft look
  //       path.setAttribute('opacity', '0.8');
  //     });

  //   }, 150);
  // }
  private resolveEdgeColor(pathId: string, colorMap: Map<string, string>): string | null {
    // ApexTree path id = "{parentSanitizedId}-{childSanitizedId}"
    // Sanitized IDs are either:
    //   plain UUID:   xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx  → 5 parts when split by '-'
    //   prefixed:     n-xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx → 6 parts when split by '-'

    const parts = pathId.split('-');
    const total = parts.length;

    // Each ID is either 5 or 6 parts. Total parts = parentParts + childParts
    // Possible combinations: 5+5=10, 5+6=11, 6+5=11, 6+6=12
    const possibleSplits: number[] = [];

    if (total === 10) possibleSplits.push(5);           // 5+5
    if (total === 11) possibleSplits.push(5, 6);        // 5+6 or 6+5
    if (total === 12) possibleSplits.push(6);           // 6+6

    for (const splitAt of possibleSplits) {
      const parentId = parts.slice(0, splitAt).join('-');
      const childId = parts.slice(splitAt).join('-');
      const key = `${parentId}-${childId}`;

      if (colorMap.has(key)) {
        return colorMap.get(key)!;
      }
    }

    return null;
  }





  private buildEdgeColorMap(svg: SVGSVGElement): Map<string, string> {
    const colorMap = new Map<string, string>();

    const nodes = svg.querySelectorAll<SVGGElement>('g');

    nodes.forEach((g) => {
      const nodeId = g.getAttribute('data-id') || g.getAttribute('id');
      if (!nodeId) return;

      const div = g.querySelector('foreignObject > div') as HTMLElement | null;

      if (div) {
        const bg = window.getComputedStyle(div).backgroundColor;
        if (bg) {
          colorMap.set(nodeId, bg);
        }
      }
    });

    return colorMap;
  }

  // private applyEdgeColors(svg: SVGSVGElement, colorMap: Map<string, string>): void {
  //   svg.querySelectorAll<SVGPathElement>('path[id]').forEach(path => {
  //     const id = path.getAttribute('id') ?? ''
  //     if (id.length !== 73) return
  //     const color = colorMap.get(id.substring(37))
  //     if (color) {
  //       path.setAttribute('stroke', color)
  //       path.setAttribute('stroke-width', '2')
  //     }
  //   })
  // }

  private applyEdgeColors(svg: SVGSVGElement, colorMap: Map<string, string>): void {
    svg.querySelectorAll<SVGPathElement>('path[id]').forEach(path => {
      const id = path.getAttribute('id')
      if (!id) return

      // ✅ Extract nodeId safely (last part of id)
      const parts = id.split('-')
      const nodeId = parts[parts.length - 1]

      const color = colorMap.get(nodeId)

      if (color) {
        path.setAttribute('stroke', color)
        path.setAttribute('stroke-width', '2')
      }
    })
  }

  //   private applyEdgeColors(svg: SVGSVGElement, colorMap: Map<string, string>): void {
  //   svg.querySelectorAll<SVGPathElement>('path').forEach((path) => {
  //     const id = path.getAttribute('id');
  //     if (!id) return;

  //     const parts = id.split('-');
  //     const nodeId = parts[parts.length - 1];

  //     const color = colorMap.get(nodeId);

  //     if (color) {
  //       path.setAttribute('stroke', color);
  //       path.setAttribute('stroke-width', '2');

  //       // 🔥 CRITICAL FIX (prevents hover override)
  //       path.style.stroke = color;
  //     }
  //   });
  // }

  private getParentIdFromPath(id: string): string | null {
    if (!id) return null

    const parts = id.split('-')
    return parts.length > 1 ? parts[1] : null
  }



  //   private applyEdgeColors(svg: SVGSVGElement): void {
  //   const paths = svg.querySelectorAll<SVGPathElement>('path')

  //   let index = 0

  //   paths.forEach(path => {
  //     // 👇 Assign color in sequence (stable)
  //     const color = this.colors[index % this.colors.length]

  //     path.setAttribute('stroke', color)
  //     path.setAttribute('stroke-width', '2')

  //     index++
  //   })
  // }
  // ================= COLOR HELPERS =================

  private colors = ['#c52d5a', '#4ECDC4', '#FFD93D', '#6C5CE7', '#00B894', '#6FA4AF', '#D2C4B4']
  private colorIndex = 0

  // private getDifferentColor(parentColor?: string): string {
  //   let color = this.colors[this.colorIndex % this.colors.length]
  //   this.colorIndex++

  //   if (color === parentColor) {
  //     color = this.colors[this.colorIndex % this.colors.length]
  //     this.colorIndex++
  //   }

  //   return color
  // }

  private getDifferentColor(): string {
    // return '#F5F5F5'
    return 'linear-gradient(135deg, #f8f9fa, #cfd9df)'

  }

  private resoleImageUrl(fileName: string): string {
    // if (!url) return this.defaultAvatar
    // if (url.startsWith('http')) return url
    return `${this.apiEndpoint}/uploads/${fileName}`



    if (!fileName) {
      return this.getInitials()
    }

    // If already full URL, return as is
    if (fileName.startsWith('http')) {
      return fileName
    }

    return `${environment.apiBaseUrl}/uploads/${fileName}`
  }

  private resolveImageUrl(url: string): string {
    if (!url) return this.defaultAvatar
    if (url.startsWith('http')) return url
    // return `${this.apiEndpoint}/uploads/${url}`\
    return `${environment.apiBaseUrl}/uploads/${url}`

  }




  // ================= UTILS =================

  // private findNode(currentNode: any, nodeId: string): any | null {
  //   if (currentNode.id === nodeId) return currentNode

  //   for (const child of currentNode.children || []) {
  //     const found = this.findNode(child, nodeId)
  //     if (found) return found
  //   }

  //   return null
  // }

  private findNode(currentNode: any, nodeId: string): any | null {
    if (currentNode.id === nodeId) return currentNode

    // ✅ Search both visible AND hidden children
    const allChildren = [
      ...(currentNode.children || []),
      ...(currentNode._hiddenChildren || [])
    ]

    for (const child of allChildren) {
      const found = this.findNode(child, nodeId)
      if (found) return found
    }

    return null
  }
}


